import { DatePipe } from '@angular/common';
import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { IEms } from '../../../../models/ems';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-ems-table',
  imports: [PanelModule, TableModule, DatePipe, TooltipModule],
  templateUrl: './ems-table.html',
  styleUrl: './ems-table.css',
})
export class EmsTable {
  EMSList = input.required<IEms[]>();
  isLoading = input.required<boolean>();
  readonly locale = inject(LOCALE_ID);
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();
}
